import React from "react";
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { Button, Modal } from "react-bootstrap";
import { clearError } from "../../redux/actions/serverManagerAction";




class FunctionContainer extends React.Component {



    render() {

        const showError = (this.props.error !== undefined && this.props.error !== null)

        return (
            <div className="single-page">
                {showError ?
                    <Modal show={showError} >
                        <Modal.Header closeButton>
                            <Modal.Title>Erreur !</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            {typeof this.props.error === "string" ?
                                this.props.error
                                : Object.keys(this.props.error).map(item => {
                                    return (<p>{item}:{this.props.error[item]}  </p>)
                                })
                            }
                        </Modal.Body>
                        <Modal.Footer>
                            <Button onClick={() => {
                                
                                this.props.dispatch(clearError())
                                
                            }}
                            >Close</Button>
                        </Modal.Footer>
                    </Modal>

                    : null
                }

                {this.props.Content}
            </div>
        )
    }

}


const mapStateToProps = (state) => {
    return ({
        authorized: state.authentication.authorized,
        contentHeight: state.app.contentHeight,
        error: state.server.error,
        onModalClose: state.server.onModalClose
    })
}

FunctionContainer.propTypes = {
    dispatch: PropTypes.func,
    contentHeight: PropTypes.number,
    authorized: PropTypes.bool,
    error: PropTypes.func |PropTypes.object | PropTypes.bool | PropTypes.number
};

export default connect(mapStateToProps)(FunctionContainer);
